import { FormattedDateTime, Row, Table } from '@elotech/components';
import { QuickView, StatusAssinatura, TableContainer } from 'common/components';

import { ProtocoloArquivoDTO, ProtocoloAssinaturaDTO } from '../../type';

type Props = {
  arquivo: ProtocoloArquivoDTO;
  loading: boolean;
  onClose: () => void;
};

export const AssinaturaQuickView = ({ arquivo, loading, onClose }: Props) => {
  const docRecusado = arquivo.assinaturas?.some(a => a.dataRecusa);
  return (
    <>
      <QuickView onClose={onClose} fixed hasScroll>
        <QuickView.Header>
          <Row>
            <QuickView.Item
              size={12}
              header="Nome documento"
              value={arquivo.nome}
            />
          </Row>
        </QuickView.Header>
        <Row style={{ marginLeft: 1, marginRight: 1 }}>
          <TableContainer>
            <Table loading={loading} values={arquivo.assinaturas || []}>
              <Table.Column
                header="Nome Assinante"
                value={(assinatura: ProtocoloAssinaturaDTO) =>
                  assinatura.usuario.nome
                }
              />

              <Table.Column
                header="Dt/Hr Atualização"
                value={(assinatura: ProtocoloAssinaturaDTO) => (
                  <FormattedDateTime
                    value={assinatura.dataAssinatura || assinatura.dataRecusa}
                  />
                )}
              />

              <Table.Column
                header="Status"
                value={(assinatura: ProtocoloAssinaturaDTO) => (
                  <StatusAssinatura
                    situacao={assinatura.situacao}
                    motivoRecusa={assinatura.motivoRecusa}
                  />
                )}
              />

              <Table.Column
                header="Motivo Recusa"
                defaultHidden={!docRecusado}
                value={(assinatura: ProtocoloAssinaturaDTO) =>
                  assinatura.motivoRecusa
                }
              />
            </Table>
          </TableContainer>
        </Row>
      </QuickView>
    </>
  );
};
